export default {
	form: {
		returnTypeRequired: "Le type de retour est requis",
		targetAttendanceTypeRequired: "Veuillez spécifier le type de carte",
	},
	fulfill: "Accomplir",
	fulfilled: "Accompli",
	debit: "Débiter",
	delete: "Supprimer",
	deleteConfirmTitle: "Supprimer le retour ?",
	deleteConfirmText: "Cette action est irréversible.",
	messages: {
		createError: "Erreur lors de la création du retour",
		created: "Retour créé avec succès",
		debitError: "Erreur lors du débit du retour",
		debited: "Retour débité : {remaining}/{total}",
		deleteError: "Erreur lors de la suppression du retour",
		deleted: "Retour supprimé",
		fulfillError: "Erreur lors de l'accomplissement du retour",
		fulfilled: "Retour accompli",
		loadError: "Erreur lors du chargement des retours",
	},
	newReturn: "Nouveau retour",
	noReturns: "Aucun retour",
	pending: "En attente",
	returnType: {
		COUNTER: "Compteur",
		INDEFINITE: "Indéfini",
		RESERVATION: "Réservation",
		NEXT_RITUAL: "Prochain rituel",
		SPECIFIC_RITUAL: "Rituel spécifique",
		SPECIFIC_DATE: "Date spécifique",
	},
	fields: {
		person: "Personne",
		type: "Type",
		target: "Destination",
		status: "Situation",
		notes: "Notes",
	},
	title: "Retours",
};
